import es from 'date-fns/locale/es';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Row as PRRow } from 'primereact/row';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as PROFILE from "../../../constants/profile";
import { PRODUCTION_REPORTS } from '../../../constants/reports';
import { useAuth } from '../../../hooks/useAuth';
registerLocale('es', es)

function WeeklyProduction() {

  // #region consts and vars  

  const toast = useRef(null);  
  const { hasPermission } = useAuth();
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedWeeklyReportType, setSelectedWeeklyReportType] = useState(null);
  const [report, setReport] = useState([]);
  const [reportHeader, setReportHeader] = useState(null);
  const [loading, setLoading] = useState(false);  
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [alertSuccessIsVisible, setAlertSuccessIsVisible] = useState(false);
  const [alertWarningIsVisible, setAlertWarningIsVisible] = useState(false);
  const weeklyProductionTypes = [{
    id: PRODUCTION_REPORTS.BY_SELL_CHANNEL,
    description: 'Producción Por Canal De Venta',
    fileName: 'producción-por-canal-de-venta'
  }, {
    id: PRODUCTION_REPORTS.BY_DRIVER,
    description: 'Producción Por Conductor',
    fileName: 'producción-por-conductor'
  }, {
    id: PRODUCTION_REPORTS.BY_VEHICLE,
    description: 'Producción Por Unidad',
    fileName: 'producción-por-unidad'
  }];

  // #endregion

  // #region methods

  const getYears = () => {
    fetch(`${process.env.REACT_APP_API_URL}/order/cmbYear`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _years = data.responseObject;
          console.log("years", _years);
          setYears(_years);
        }
      });
  };

  const getProductionReport = (
    year,
    reportTypeId
  ) => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/productionReport/getReport`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year,
        reportTypeId
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {                
        setReport(data.responseObject.data);
        setReportHeader(data.responseObject.header);     
      } else {
        setAlertWarningIsVisible(true);
      }
      setLoading(false);
    }, (error) => {
      setLoading(false);
      console.error("Error getting weekly report", error);     
    });
  };

  const getExcelReport = (
    year,
    reportTypeId,
    fileName
  ) => {
    fetch(`${process.env.REACT_APP_API_URL}/productionReport/generate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year,
        reportTypeId
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        downloadExcel(data.responseObject, `${fileName}-${year}`)
      } else {
        setAlertWarningIsVisible(true);
      }
    });
  };

  const downloadExcel = (data, fileName) => {
    var link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + data;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const resetAlerts = () => {
    setAlertWarningIsVisible(false);
    setAlertSuccessIsVisible(false);
  };

  // #endregion

  // #region events

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    getYears();
  }, []);

  const onYearChange = (e) => {    
    setSelectedYear(e.value);
  };

  const onWeeklyReportTypeChange = (e) => {
    setSelectedWeeklyReportType(e.value);
  };

  const onSearchPress = () => {
    getProductionReport(
      selectedYear.year,
      selectedWeeklyReportType.id
    );
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  };

  const onExportExcelButtonPress = () => {    
    getExcelReport(
      selectedYear.year,
      selectedWeeklyReportType.id,
      selectedWeeklyReportType.fileName
    ); 
  };

  // #endregion

  // #region templates

  const alertsTemplate = (
    <>
      <Row>
        <Col>
          <Toast ref={toast} />
          <Alert
            key='success'
            variant='success'
            hidden={!alertSuccessIsVisible}>
          </Alert>
          <Alert
            key='warning'
            variant='warning'
            hidden={!alertWarningIsVisible}>
            ¡Error al generar reporte!.
          </Alert>
        </Col>
      </Row>
    </>
  );

  const filtersTemplate = (
    <>
      <Row>
        <Col>
          <Dropdown
            value={selectedYear}
            options={years}
            onChange={onYearChange}
            optionLabel="description"
            placeholder="Selecciona el año"
            className='p-inputtext-sm m-2'
          />
          <Dropdown
            value={selectedWeeklyReportType}
            options={weeklyProductionTypes}
            onChange={onWeeklyReportTypeChange}
            optionLabel="description"
            placeholder="Selecciona el Tipo de reporte"
            className='p-inputtext-sm'
          />
          <Button
            type="button"
            icon="pi pi-search"
            onClick={onSearchPress}
            className="p-button-raised p-button-sm p-button-primary m-2"            
            label='Buscar' 
            disabled={!selectedYear||!selectedWeeklyReportType}
          />           
        </Col>
      </Row>
    </>
  );


  const tableHeaderTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              value={globalFilter}
              onChange={onGlobalFilterChange}
              placeholder="Filtrar"
              className='p-inputtext-sm'
            />
          </span>
        </Col>
        <Col>
          {
            hasPermission(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS) && (
              <Button
                className="p-button-raised p-button-sm p-button-success mr-2 float-end"
                type="button"
                icon="pi pi-file-excel"
                data-pr-tooltip="XLS"
                label='Exportar'
                onClick={onExportExcelButtonPress}
              />
            )
          }
        </Col>
      </Row>
    </>
  );

  const tableColumnGroupTemplate = (
    <ColumnGroup>
      {
        (reportHeader && reportHeader.level0) && (
          <PRRow>
            {
              reportHeader.level0.map((header, index) => (
                <Column
                  key={index}
                  header={header.desc}
                  colSpan={header.colSpan}                 
                />
              ))
            }
          </PRRow> 
        )
      }     
      {
        (reportHeader && reportHeader.level1) && (
          <PRRow>
            {
              reportHeader.level1.map((header, index) => (                
                index === 0 ? (
                  <Column
                    key={index}
                    header={header.desc}
                    sortable
                    sortField={header.colName}
                  />
                ) : (
                  <Column
                    key={index}
                    header={header.desc}
                    className='text-end'
                    sortable
                    sortField={header.colName}
                  />   
                )                  
              ))
            }
          </PRRow>
        )
      }   
    </ColumnGroup>
  );

  const tableColumnsTemplate = (
    reportHeader ? reportHeader.headerName.map((field, index) => (
      index === 0 ? (
        <Column key={index} field={field} className='app-w-150-px' />
      ) : (
        <Column key={index} field={field} className='app-w-250-px text-end' />
      )         
    )) : null
  );

  const tableTemplate = (
    <>
      {
        (report && reportHeader) && (
          <DataTable
            value={report}
            paginator
            className="p-datatable-customers"
            showGridlines
            stripedRows
            header={tableHeaderTemplate}
            rows={50}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}
            filters={filters}
            filterDisplay="menu"
            loading={loading}
            responsiveLayout="scroll"
            globalFilterFields={reportHeader.headerName}
            emptyMessage="No records found."
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"            
            headerColumnGroup={tableColumnGroupTemplate}                   
            // footerColumnGroup={footerGroup}
          >
            {tableColumnsTemplate}
          </DataTable>          
        )
      }
    </>
  );

  // #endregion

  return (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Producción semanal
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {alertsTemplate}
          </Col>
        </Row>
        <Row>
          <Col>
            {filtersTemplate}
          </Col>
        </Row>
        <Row>
          <Col>
            {tableTemplate}
          </Col>
        </Row>
      </article>
    </>
  );
}

export default WeeklyProduction;